
import { URLSearchParams } from "@angular/http";
import { Component } from '@angular/core';

import { NavController, NavParams } from 'ionic-angular';

import { UsuarioService } from '../../providers/usuario-service';
import { LoginService } from '../../providers/login-service';
import { AlertService } from '../../providers/alert-service';

import { environment } from '../../environments/environment';
import { AmbienteService } from "../../providers/ambiente-service";

@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {
  usuario: {
    login: string,
    senha: string
  };
  loading: boolean = false;
  ENTER_KEY_CODE = 13;
  loginDoJurisdicionado: boolean = false;

  versaoApp: any;
  versaoApi: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private usuarioService: UsuarioService,
    private loginService: LoginService,
    private alertService: AlertService,
    private ambienteService: AmbienteService
  ) {

    this.usuario = {
      // login: "ey",
      // senha: "Tce1234567890!@#"
      login: '',
      senha: ''
    };

    let params = new URLSearchParams(window.location.search);

    if (params.rawParams.length > 0) {
      this.loginDoJurisdicionado = true;
      this.loginJurisdicionado(params.get('?login'), params.get('senha'));
    }

    // this.login();

    this.versaoApp = environment.VERSION;
    this.ambienteService.getVersaoApi().subscribe(versao => this.versaoApi = versao);
  }
/*
  login() {
    this.loading = true;
    this.loginService.autenticarAnalista(this.usuario).subscribe(data => {
      this.usuarioService.setUsuario(data);
      this.loginService.setTokenUsuario(data.token);
    },
      error => {
        this.alertService.mostraAlerta("Falha na autenticação!", error.mensagem);
        this.loading = false;
        this.usuario.senha = '';
      });

    let check = false;

    setInterval(() => {

      check = false;

      this.alertService.mostraModalConfirmacao("Autenticação Expirada!", "Você será deslogado do sistema em 60s. Deseja renovar sua autenticação?", callback => {
        if (callback) {

          check = true;

          this.loginService.autenticarAnalista(this.usuario).subscribe(data => {
            this.loginService.setTokenUsuario(data.token);

            this.usuarioService.setToken(data.token);

          }, error => {
            this.alertService.mostraAlerta("Houve um erro ao renovar a autenticação.", error);
            console.log("erro: " + error);
          });
        } else {
          window.open('http://agora.tce.ce.gov.br', '_self');
        }
      });
    }, 3540000); // 59min

    setInterval(() => {
      if (!check) {
        window.open('http://agora.tce.ce.gov.br', '_self');
      }
    }, 3600000); // 60min
  }
*/

login() {
  this.loading = true;
  
  this.loginService.autenticarUsuario(this.usuario).subscribe(data => {
    this.usuarioService.setUsuario(data);
    this.loginService.setTokenUsuario(data.token);

    window.history.pushState({ path: window.location.pathname }, '', window.location.pathname)
   // this.alertService.mostraAlerta("Atenção!", "O prazo de envio das prestações de contas anuais do exercício de 2024 se encerra em 30/06/2025.");

  }, error => {
    console.log(error);
    this.alertService.mostraAlerta("Falha na autenticação!", error.mensagem);
    this.loading = false;
  });

  let check = false;

  setInterval(() => {

    check = false;

    this.alertService.mostraModalConfirmacao("Autenticação Expirada!", "Você será deslogado do sistema em 60s. Deseja renovar sua autenticação?", callback => {
      if (callback) {

        check = true;

        this.loginService.autenticarUsuario(this.usuario).subscribe(data => {
          this.loginService.setTokenUsuario(data.token);

          this.usuarioService.setToken(data.token);

        }, error => {
          this.alertService.mostraAlerta("Houve um erro ao renovar a autenticação.", error);
          console.log("erro: " + error);
        });
      } else {
        window.open('http://agora.tce.ce.gov.br', '_self');
      }
    });
  }, 3540000); // 59min

  setInterval(() => {
    if (!check) {
      window.open('http://agora.tce.ce.gov.br', '_self');
    }
  }, 3600000); // 60min
}

  loginJurisdicionado(login, senha) {
    if (login != null &&
      senha != null) {

      let dadosJurisdicionado = {
        "login": login,
        "senha": senha
      };

      this.loginService.autenticarJurisdicionado(dadosJurisdicionado).subscribe(data => {
        this.usuarioService.setUsuario(data);
        this.loginService.setTokenUsuario(data.token);

        window.history.pushState({ path: window.location.pathname }, '', window.location.pathname)
        //this.alertService.mostraAlerta("Atenção!", "O prazo de envio das prestações de contas anuais do exercício de 2024 se encerra em 30/06/2025.");

      }, error => {
        console.log(error);
        this.alertService.mostraAlerta("Falha na autenticação!", error.mensagem);
        this.loading = false;
      });

      let check = false;

      setInterval(() => {

        check = false;

        this.alertService.mostraModalConfirmacao("Autenticação Expirada!", "Você será deslogado do sistema em 60s. Deseja renovar sua autenticação?", callback => {
          if (callback) {

            check = true;

            this.loginService.autenticarJurisdicionado(dadosJurisdicionado).subscribe(data => {

              this.loginService.setTokenUsuario(data.token);

              this.usuarioService.setToken(data.token);
            }, error => {
              this.alertService.mostraAlerta("Houve um erro ao renovar a autenticação.", error);
              console.log("erro: " + error);
            });
          } else {
            window.open('https://www.tce.ce.gov.br:8082/eTCE/login.faces', '_self');
          }
        });
      }, 3540000); // 59 min

      setInterval(() => {
        if (!check) {
          window.open('https://www.tce.ce.gov.br:8082/eTCE/login.faces', '_self');
        }
      }, 3600000); // 60 min
    }
    else {
      this.alertService.mostraAlerta("Login Jurisdicionado", "Não foi possível identificar o login e senha como parâmetros, favor verificar a URL.");
    }
  }

  cadastrarUsuario(){
    window.open('https://servicoseletronicos.tce.ce.gov.br/eTCE/cadastro.faces', '_blank');
  }

  keyDownFunction(event) {
    if (event.keyCode == this.ENTER_KEY_CODE) {
      if (this.usuario.login != "" &&
        this.usuario.senha != "") {
        this.login();
      }
      else {
        // this.alertService.mostraAlerta("", "Preencha o campo usuário e senha");
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/pages/login/login.ts